module.exports = __webpack_public_path__ + "img/Feature.727bbf39.png";